import { sessionState$ } from '../state';
import { useWebsocketConnection } from './useWebsocketConnection.hook';
import { useWebsocketEvent } from './useWebsocketEvent.hook';

/**
 * 🔌 Hook for managing WebSocket session lifecycle
 * Handles connection events and session state management
 */
export const useSession = () => {
  const connection = useWebsocketConnection();

  useWebsocketEvent(connection, 'Close', (event) => {
    console.log('🔌❌ WebSocket connection closed:', event);
    sessionState$.expireSession();
  });
};
